import { CheckboxStyles, CheckboxTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Checkbox } from "./checkbox.js";
/**
 * The Fabric Checkbox component.
 *
 * @public
 */
export const definition = Checkbox.compose({
    name: `${DesignSystem.prefix}-checkbox`,
    template: CheckboxTemplate,
    styles: CheckboxStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=checkbox.definition.js.map